import React, { FC } from 'react'
import { List } from 'semantic-ui-react'
//@ts-ignore
import FormField from 'shared/newFormElements'
import { LKLabel } from 'loankeeper-common/components'
import { translate } from '../../helpers'
import { RFInitialValues } from '../../constants'

const AccSearchStatus: FC<{
  selector: boolean
  status?: boolean
}> = ({ selector, status }) => (
  <List>
    <List.Item>
      <FormField
        type="checkbox"
        name="status"
        disabled={selector}
        defaultValue={RFInitialValues.status}
        label={
          <label>
            <LKLabel alias="square_grey" text={translate('chk_closed')} />
          </label>
        }
        indeterminable
      />
    </List.Item>
  </List>
)

export default AccSearchStatus
